module.exports = __webpack_public_path__ + "img/p012.06815708.png";